import { createSlatePlugin, TElement } from "platejs";
import { toNodeProps } from "./withNodeProps";

const INLINE_TAG_NAMES = [
  "SMALL",
  "ABBR",
  "TIME",
  "CITE",
  "Q",
  "KBD",
  "DFN",
  "DATA",
  "INS",
  "DEL",
  "BDI",
  "BDO",
  "VAR",
  "SAMP",
];

export type TInlineElement = TElement & {
  tagName?: keyof HTMLElementTagNameMap;
};

export const InlineElementPlugin = createSlatePlugin({
  key: "inline-element",
  node: {
    isElement: true,
    isInline: true,
  },
  parsers: {
    html: {
      deserializer: {
        rules: [{ validNodeName: INLINE_TAG_NAMES }],
        parse: ({ element, type }) => ({
          type,
          tagName: element.tagName.toLowerCase(),
        }),
        toNodeProps: toNodeProps,
      },
    },
  },
});
